import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { SelectRadioGroup } from "@circle-react-shared/uikit/SelectRadioGroup";
import type { Appearance } from "./BuilderUI/Store/interfaceSlice";

export const isValidAppearance = (value: string): value is Appearance =>
  value === "light" || value === "dark";

export interface AppearanceToggleProps {
  currentAppearance: Appearance;
  onAppearanceToggle?: (appearance: Appearance) => void;
  onChange: (value: Appearance) => void;
  optionClassName?: string;
}

export const AppearanceToggle = ({
  currentAppearance,
  onChange,
  optionClassName = "",
  onAppearanceToggle,
}: AppearanceToggleProps) => {
  const options: {
    value: Appearance;
    label: ReactNode;
    tooltipText?: string;
  }[] = [
    {
      value: "light",
      tooltipText: t("builder_ui.appearance.light"),
      label: (
        <Icon
          type="20-builder-light-mode"
          size={20}
          aria-label={t("builder_ui.appearance.light")}
        />
      ),
    },
    {
      value: "dark",
      tooltipText: t("builder_ui.appearance.dark"),
      label: (
        <Icon
          type="20-builder-dark-mode"
          size={20}
          aria-label={t("builder_ui.appearance.dark")}
        />
      ),
    },
  ];

  const handleChange = (value: string) => {
    if (!isValidAppearance(value)) {
      return;
    }

    onChange(value);
    onAppearanceToggle?.(value);
  };

  return (
    <SelectRadioGroup
      value={currentAppearance}
      options={options}
      onChange={handleChange}
      size="sm"
      className="gap-1"
      optionClassName={optionClassName}
      aria-label={t("builder_ui.appearance.toggle")}
    />
  );
};
